

import Vue from "vue";
import { ReminderService } from "@/services/reminder-service";
import { ReminderLayout } from "@/utils/reminder-layouts/reminder-layout";
import { PdfViewer } from "@/utils/pdf-viewer";

export default Vue.extend({
	data(){
		return {
			pdfViewer: new PdfViewer(),
			url: ""
		};
	},
	props: {
		layout: Object as () => ReminderLayout
	},
	watch: {
		layout: {
			deep: true,
			immediate: true,
			handler() {
				this.preview();
			}
		}
	},
	methods: {
		async preview() {
			let blob = await ReminderService.getReminderLayoutPreview(this.layout, "nl-be");
			this.pdfViewer.setPdfBlob(blob);
			await this.pdfViewer.open();
			this.url = this.pdfViewer.getURL();
		}
	},
	destroyed(){
		this.pdfViewer.close();
	},
	components: {},
	i18nEx: {
		componentPrefix: "components.reminder-layout-editor"
	}
});
